export const CHANNELS = [
  {
    contentTargetId: 760,
    code: 'web3__sections__international_americas',
    friendlyName: 'Americas',
    isTierOneSite: true,
  },
  {
    contentTargetId: 686,
    code: 'web3__sections__international_asia',
    friendlyName: 'Asia',
    isTierOneSite: true,
  },
  {
    contentTargetId: 1466,
    code: 'web3__sections__international_austria',
    friendlyName: 'Austria',
    isTierOneSite: true,
  },
  {
    contentTargetId: 1187,
    code: 'web3__sections__international_france',
    friendlyName: 'France',
    isTierOneSite: true,
  },
  {
    contentTargetId: 2,
    code: 'web3__sections__citywire_money',
    friendlyName: 'Funds Insider',
    isTierOneSite: true,
  },
  {
    contentTargetId: 663,
    code: 'web3__sections__international_germany',
    friendlyName: 'Germany',
    isTierOneSite: true,
  },
  {
    contentTargetId: 954,
    code: 'web3__sections__investment_trust_insider',
    friendlyName: 'Investment Trust Insider',
    isTierOneSite: true,
  },
  {
    contentTargetId: 687,
    code: 'web3__sections__international_italy',
    friendlyName: 'Italy',
    isTierOneSite: true,
  },
  {
    contentTargetId: 1386,
    code: 'web3__sections__international_middle_east',
    friendlyName: 'Middle East',
    isTierOneSite: true,
  },
  {
    contentTargetId: 1,
    code: 'web3__sections__new_model_adviser',
    friendlyName: 'New Model Adviser',
    isTierOneSite: true,
  },
  {
    contentTargetId: 3,
    code: 'web3__sections__citywire_global',
    friendlyName: 'Selector',
    isTierOneSite: true,
  },
  {
    contentTargetId: 867,
    code: 'web3__sections__smart_alpha',
    friendlyName: 'Smart Alpha',
    isTierOneSite: true,
  },
  {
    contentTargetId: 1186,
    code: 'web3__sections__international_spain',
    friendlyName: 'Spain',
    isTierOneSite: true,
  },
  {
    contentTargetId: 742,
    code: 'web3__sections__international_switzerland',
    friendlyName: 'Switzerland',
    isTierOneSite: true,
  },
  {
    contentTargetId: 859,
    code: 'web3__sections__international_usa',
    friendlyName: 'USA Pro Buyer',
    isTierOneSite: true,
  },
  {
    contentTargetId: 1158,
    code: 'web3__sections__international_registered_investment_advisers',
    friendlyName: 'USA RIA',
    isTierOneSite: true,
  },
  {
    contentTargetId: 4,
    code: 'web3__sections__wealth_manager',
    friendlyName: 'Wealth Manager',
    isTierOneSite: true,
  },
];
